// MARK://dhk8/admin-shell/lib/queries/recipes
// Queries tipadas del recetario — F1.6 / ADR-0009. El Admin lee recetas por el
// grafo (catalog-recipes), tenant del JWT (RLS). Los nombres de insumo se resuelven
// por la federación (RecipeIngredient.product → erp-products). nutrition se omite
// (JSON) — el UI lo deja en null. F9.4: CRUD + ingredientes por el grafo (mutations); setters de metadata fina (station/prep/yield/allergens/image) y archive/duplicate siguen REST.
import { graphql } from '../../gql/index.js'

export const AdminRecipesQuery = graphql(`
  query AdminRecipes($status: String, $limit: Int) {
    recipes(status: $status, limit: $limit) {
      items {
        id
        tenantId
        productId
        name
        yieldServings
        yieldPercent
        cost
        costMissing
        active
        status
        allergens
        kdsStation
        prepTimeMin
        imageUrl
        createdAt
        updatedAt
        ingredients {
          id
          productId
          quantity
          unit
        }
        subRecipes {
          subId
          name
          quantity
        }
      }
    }
  }
`)

export const AdminRecipeQuery = graphql(`
  query AdminRecipe($id: ID!) {
    recipe(id: $id) {
      id
      tenantId
      productId
      variantSkuId
      name
      yieldServings
      yieldPercent
      yieldQuantity
      yieldUnit
      version
      cost
      costMissing
      active
      status
      allergens
      kdsStation
      prepTimeMin
      imageUrl
      createdAt
      updatedAt
      ingredients {
        id
        productId
        stockItemId
        quantity
        unit
        wasteFactor
        optional
        sortOrder
      }
      subRecipes {
        subId
        name
        quantity
      }
    }
  }
`)


// ── F9.4: escrituras del recetario por el grafo (catalog-recipes, tenant del JWT, RLS, IDOR-guard) ──
export const AdminCreateRecipeMutation = graphql(`
  mutation AdminCreateRecipe($input: RecipeCreateInput!) {
    createRecipe(input: $input) {
      id
      tenantId
      productId
      variantSkuId
      name
      yieldServings
      yieldPercent
      yieldQuantity
      yieldUnit
      version
      cost
      costMissing
      active
      status
      allergens
      kdsStation
      prepTimeMin
      imageUrl
      createdAt
      updatedAt
      ingredients {
        id
        productId
        stockItemId
        quantity
        unit
        wasteFactor
        optional
        sortOrder
      }
      subRecipes {
        subId
        name
        quantity
      }
    }
  }
`)

export const AdminUpdateRecipeMutation = graphql(`
  mutation AdminUpdateRecipe($id: ID!, $input: RecipeUpdateInput!) {
    updateRecipe(id: $id, input: $input) {
      id
      tenantId
      productId
      variantSkuId
      name
      yieldServings
      yieldPercent
      yieldQuantity
      yieldUnit
      version
      cost
      costMissing
      active
      status
      allergens
      kdsStation
      prepTimeMin
      imageUrl
      createdAt
      updatedAt
      ingredients {
        id
        productId
        stockItemId
        quantity
        unit
        wasteFactor
        optional
        sortOrder
      }
      subRecipes {
        subId
        name
        quantity
      }
    }
  }
`)

export const AdminDeleteRecipeMutation = graphql(`
  mutation AdminDeleteRecipe($id: ID!) {
    deleteRecipe(id: $id)
  }
`)

export const AdminRecalcRecipeCostMutation = graphql(`
  mutation AdminRecalcRecipeCost($id: ID!) {
    recalcRecipeCost(id: $id) {
      id
      tenantId
      productId
      variantSkuId
      name
      yieldServings
      yieldPercent
      yieldQuantity
      yieldUnit
      version
      cost
      costMissing
      active
      status
      allergens
      kdsStation
      prepTimeMin
      imageUrl
      createdAt
      updatedAt
      ingredients {
        id
        productId
        stockItemId
        quantity
        unit
        wasteFactor
        optional
        sortOrder
      }
      subRecipes {
        subId
        name
        quantity
      }
    }
  }
`)

export const AdminPublishRecipeMutation = graphql(`
  mutation AdminPublishRecipe($id: ID!) {
    publishRecipe(id: $id) {
      id
      tenantId
      productId
      variantSkuId
      name
      yieldServings
      yieldPercent
      yieldQuantity
      yieldUnit
      version
      cost
      costMissing
      active
      status
      allergens
      kdsStation
      prepTimeMin
      imageUrl
      createdAt
      updatedAt
      ingredients {
        id
        productId
        stockItemId
        quantity
        unit
        wasteFactor
        optional
        sortOrder
      }
      subRecipes {
        subId
        name
        quantity
      }
    }
  }
`)

export const AdminUnpublishRecipeMutation = graphql(`
  mutation AdminUnpublishRecipe($id: ID!) {
    unpublishRecipe(id: $id) {
      id
      tenantId
      productId
      variantSkuId
      name
      yieldServings
      yieldPercent
      yieldQuantity
      yieldUnit
      version
      cost
      costMissing
      active
      status
      allergens
      kdsStation
      prepTimeMin
      imageUrl
      createdAt
      updatedAt
      ingredients {
        id
        productId
        stockItemId
        quantity
        unit
        wasteFactor
        optional
        sortOrder
      }
      subRecipes {
        subId
        name
        quantity
      }
    }
  }
`)

export const AdminAddRecipeIngredientMutation = graphql(`
  mutation AdminAddRecipeIngredient($recipeId: ID!, $input: RecipeIngredientAddInput!) {
    addRecipeIngredient(recipeId: $recipeId, input: $input) {
      id
      productId
      stockItemId
      quantity
      unit
      wasteFactor
      optional
      sortOrder
    }
  }
`)

export const AdminUpdateRecipeIngredientMutation = graphql(`
  mutation AdminUpdateRecipeIngredient($recipeId: ID!, $ingredientId: ID!, $input: RecipeIngredientUpdateInput!) {
    updateRecipeIngredient(recipeId: $recipeId, ingredientId: $ingredientId, input: $input) {
      id
      productId
      stockItemId
      quantity
      unit
      wasteFactor
      optional
      sortOrder
    }
  }
`)

export const AdminRemoveRecipeIngredientMutation = graphql(`
  mutation AdminRemoveRecipeIngredient($recipeId: ID!, $ingredientId: ID!) {
    removeRecipeIngredient(recipeId: $recipeId, ingredientId: $ingredientId)
  }
`)

// ── F9.4: sub-recetas (una receta hija como componente de otra; IDOR-guard por padre) ──
export const AdminLinkSubRecipeMutation = graphql(`
  mutation AdminLinkSubRecipe($parentId: ID!, $input: SubRecipeLinkInput!) {
    linkSubRecipe(parentId: $parentId, input: $input) {
      subId
      name
      quantity
    }
  }
`)

export const AdminUnlinkSubRecipeMutation = graphql(`
  mutation AdminUnlinkSubRecipe($parentId: ID!, $subId: ID!) {
    unlinkSubRecipe(parentId: $parentId, subId: $subId)
  }
`)
